import gql from 'graphql-tag';

/**
 * Bản rút gọn của `productSearch`, chỉ dùng cho dropdown gợi ý ở thanh tìm kiếm.
 */
export default gql`
  query productSearch($sort: [ProductSort!]!, $filter: ProductFilter, $pagination: Pagination!) {
    productSearch(sort: $sort, filter: $filter, pagination: $pagination) {
      totalResults
      totalPage
      data {
        id
        name
        imageUrl
        supplierInternalCode
        tagImageVn
        tagImageEn
      }
    }
  }
`;
